import { matchPath } from 'react-router-dom';

function isRouteActive(location: string, route: string): boolean {
  return !!matchPath(location, route);
}

export default {
  isRouteActive,
};
